import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import api from '../services/api';

const GTMProvider = () => {
  const [gtmId, setGtmId] = useState(null);
  const location = useLocation();

  // Fetch GTM ID once on mount
  useEffect(() => {
    api.get('/site-config')
      .then(res => {
        const id = res.data?.google_tag_manager_id;
        if (id && id.startsWith('GTM-')) {
          setGtmId(id);
        }
      })
      .catch(() => {});
  }, []);

  // Inject GTM script when ID is available
  useEffect(() => {
    if (!gtmId) return;

    // Prevent duplicate injection
    if (document.getElementById('gtm-script')) return;

    // Initialize dataLayer
    window.dataLayer = window.dataLayer || [];

    // Head script
    const script = document.createElement('script');
    script.id = 'gtm-script';
    script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${gtmId}');`;
    document.head.appendChild(script);

    // Body noscript iframe
    const noscript = document.createElement('noscript');
    noscript.id = 'gtm-noscript';
    const iframe = document.createElement('iframe');
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';
    noscript.appendChild(iframe);
    document.body.insertBefore(noscript, document.body.firstChild);
  }, [gtmId]);

  // Push pageview on every route change
  useEffect(() => {
    if (!gtmId) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'pageview',
      page: location.pathname + location.search
    });
  }, [gtmId, location]);

  return null;
};

export default GTMProvider;
